import {useEffect} from 'react';

declare global {
  interface Window {
    fbq?: (command: 'track', eventName: string) => void;
  }
}

type Props = {
  event: 'CompleteRegistration';
};

export const MetaPixelEvent: React.FC<Props> = ({event}) => {
  useEffect(() => {
    window.fbq?.('track', event);
  }, [event]);

  return null;
};
